function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMccMeals = function SvgMccMeals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.784 6.883A4.111 4.111 0 0 1 34 7.111V35a2 2 0 0 1-2 2h-1.871a2 2 0 0 1-1.996-2.125l.733-11.727-1.676-.931a4 4 0 0 1-2.051-3.719l.645-11.615ZM7.913 4.392A.5.5 0 0 1 8.4 4h1.072a.5.5 0 0 1 .5.526l-.445 8.448a.5.5 0 0 0 .499.526h.523a.5.5 0 0 0 .497-.448l.906-8.604A.5.5 0 0 1 12.45 4h1.1a.5.5 0 0 1 .497.448l.906 8.604a.5.5 0 0 0 .497.448h.523a.5.5 0 0 0 .5-.526l-.445-8.448A.5.5 0 0 1 16.526 4h1.072a.5.5 0 0 1 .488.392l1.96 8.822c.81 3.64-1.27 7.127-4.53 8.338l.418 13.386A2 2 0 0 1 13.936 37H12.063a2 2 0 0 1-1.999-2.063l.419-13.385c-3.26-1.21-5.34-4.699-4.53-8.338l1.96-8.822Z",
    clipRule: "evenodd",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccMeals;